import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import styles from "./LandingPage.module.css";
import background from "./background.gif";
import YuHu from "./YuHu.png";

export default class LandingPage extends React.Component {
  render() {
    return (
      <div>
        <section
          id="home"
          className={`${styles.animation} ${styles.landingSection}`}
        >
          <div
            className={styles.landingBackground}
            style={{ backgroundImage: `url(${background})` }}
          ></div>
          <div className={styles.landingText}>
            <h1>Ng Yuen Ning</h1>
            <p>NUS Business Analytics Undergraduate</p>
          </div>
        </section>

        {/* About Us Section */}
        <div className={styles["about-us-box"]}>
          <section id="about" className={styles["about-us"]}>
            <h1>About Me</h1>
            <div className={styles["about-me-content"]}>
              <div>
                <p>
                  I am a Year 2 Business Analytics undergraduate at National
                  University of Singapore with a passion for data analytics and
                  commerce. With self-taught skills like graphic design and
                  co-curricular involvement in organisations such as AIESEC
                  Singapore, Tembusu Ambassadors and Tembusu House Committee, I
                  am committed to my personal development and learning, with
                  experience in project management, teamwork and leadership.
                </p>
              </div>
              <div>
                <p>
                  Outside of class, I enjoy a good cup of coffee and go for
                  weekly morning sessions in Tembusu Coffee House to make coffee
                  for my college mates. Beyond that, I like adventures, which is
                  why I have a One Star Kayaking and Rock Climbing Level One
                  certificate. I also like to travel so I normally go for
                  overseas trips with my friends or family during the holidays.
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Projects Section */}
        <section id="projects" className={`${styles["projects-container"]}`}>
          <div className={styles.projects}>
            <h1>Projects</h1>
            <div className={styles["carousel-container"]}>
              <div className={styles["carousel-content"]}>
                <Carousel showThumbs={false} autoPlay infiniteLoop>
                  {/* Each carousel item */}
                  <div className={styles["carousel-item"]}>
                    <a
                      href="https://yuhu.web.app/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={YuHu}
                        alt="YuHu logo"
                        style={{ width: "100px", background: "black" }}
                      />
                    </a>
                  </div>
                  <div className={styles["carousel-item"]}>
                    <p>Stay Tuned for More!</p>
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
        </section>
        <br />
        <br />
      </div>
    );
  }
}
